import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Evento, Persona, Spettacolo } from '../../../../shared/interface';

@Component({
  selector: 'app-personale-accredito-spettacolo-backoffice',
  templateUrl: './personale-accredito-spettacolo-backoffice.component.html',
  styleUrl: './personale-accredito-spettacolo-backoffice.component.css'
})
export class PersonaleAccreditoSpettacoloBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  spettacolo?: Spettacolo;
  evento?: Evento;
  personale: Persona[] = [];

  loading: boolean = false;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = Number(params['id']);
      this.loading = true;
      this.personale = [];

      this.apiService.getSpettacolo(id).subscribe({
        next: (data) => this.spettacolo = data,
        error: () => this.router.navigate(['/backoffice/spettacoli']),
        complete: () => this.loadEventoThenPersonale(id)
      });
    });
  }

  private loadEventoThenPersonale(id_spettacolo: number) {
    this.apiService.getEventoSpettacolo(id_spettacolo).subscribe({
      next: (data) => {
        this.evento = data;
        this.loadPersonale();
      },
      error: () => {
        this.apiService.ensureEventoSpettacolo(id_spettacolo).subscribe({
          next: () => {
            this.apiService.setSpettacoli();
            this.apiService.getEventoSpettacolo(id_spettacolo).subscribe({
              next: (data) => {
                this.evento = data;
                this.loadPersonale();
              },
              error: (err) => {
                this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Impossibile aprire area compagnia');
                this.router.navigate(['/backoffice/spettacoli']);
                this.loading = false;
              }
            });
          },
          error: (err) => {
            this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Impossibile creare area compagnia');
            this.router.navigate(['/backoffice/spettacoli']);
            this.loading = false;
          }
        });
      }
    });
  }

  private loadPersonale() {
    this.apiService.getPersonaleEvento(this.evento!.id).subscribe({
      next: (data) => this.personale = data || [],
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
      complete: () => { this.loading = false; }
    });
  }

}
